import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../src/app/trip-view/services/common.service';
import { CommonCabService } from './trip-view-cab/services/common-cab.service';
import { DataService } from './data.service';
import { MultiTripViewService } from './modern-multi-trip-view/services/multi-trip-view.service';
import { RouteReplayService } from './route-replay/services/route-replay.service';
import { RouteReplayDataService } from './route-replay/services/route-replay-data.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  routeReplayDataService=inject(RouteReplayDataService);
  constructor(private dataService:DataService ,private commonService: CommonService, private route: ActivatedRoute, private commonCabService: CommonCabService, private router: Router, private multiTripViewService : MultiTripViewService) {

  }
  ngOnInit(): void {
   
    this.route.queryParams.subscribe(params => {

      if (Object.keys(params).length === 0) return;

      let tripId = params['tripId']
      let buid = params['buid']
      let dutyId = params['dutyId']
      let cabId = params['cabId']
      let type = params['type'];
      let tripIds = params['tripIds'];
      let roleId = params['roleId'];
      let source = params['source'];
      if (!!dutyId)
        dutyId = Number(dutyId);
      tripId = Number(tripId)
      if (!!cabId)
        cabId = Number(cabId);
      if(!!roleId){
        roleId = Number(roleId);
        this.dataService.roleId = Number(roleId)
      }

      this.commonCabService.NONCE_TOKEN = this.commonCabService.NONCE_TOKEN ?? params['nonce'];
      this.commonService.NONCE_TOKEN = this.commonService.NONCE_TOKEN ??   params['nonce'];
      this.dataService.buid=buid;
      if(buid && source!=='SHUTTLE') {
        this.dataService.getPropertyValue().subscribe()
        this.dataService.getEtsSiteURL().subscribe()
      }
      this.commonService.buid = buid;

      if(!!tripIds
        && tripIds.length > 0)
      {
        this.multiTripViewService.tripIds = tripIds.split(',').map(Number)
        this.multiTripViewService.buid = buid;
        // this.router.navigate(['/modern-trip-view'], { queryParams: { buid , tripIds } });
      }
      this.routeReplayDataService.updateBuid(buid,source);
    
      


      // if(Object.keys(params).length != 0){
      //   let tripId =params['tripId'];
      //   let buid = params['buid'];
      //   tripId=Number(tripId);
      //   let type=params['type'];
      //   console.log('parmas',params);

      if (!!type) {
        if (type === 'cab') {
          this.commonCabService.tripId = tripId;
          this.commonCabService.buid = buid;
          this.commonCabService.dutyId = dutyId || this.commonCabService.dutyId;
          this.commonCabService.cabId = cabId || this.commonCabService.cabId;
          this.commonCabService.source = source || '';
          this.router.navigate(['/trip-view/cab'], { queryParams: { buid: buid, tripId: tripId, type: 'cab', dutyId: dutyId, cabId: cabId, roleId: roleId, ...(source ? { source } : {})} });
          if(this.commonCabService.buid)
          {
            this.commonCabService.getGeofence().subscribe(((res:any)=>
            {
              this.commonCabService.geofenceRadius=Number(res)
            }))
          }
        } else {
          this.commonService.tripId = tripId;
          this.commonService.buid = buid;
          this.commonService.dutyId = dutyId || this.commonService.dutyId;
          this.commonService.cabId = cabId || this.commonService.cabId;
          this.commonService.source = source || '';
          this.router.navigate(['/trip-view/shuttle'], { queryParams: { buid: buid, tripId: tripId, type: 'shuttle', dutyId: dutyId, cabId: cabId ,roleId: roleId, ...(source ? { source } : {})} });
          if(this.commonService.buid)
          {
            this.commonService.getGeofence().subscribe(((res:any)=>
            {
              this.commonService.geofenceRadius=Number(res)
            }))
          }
        }
      }

    });
   
  }
  title = 'trip-view';
}
